import { createContext } from 'react';
import { ModalContextProps } from './Modal.types';

const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export default ModalContext;
